export var DEPLOY_DATE = new Date('2026-04-10T13:30:43+0000');
